import * as React from 'react'
import { getHelpdeskRequestPage, getSourceOfWealthFormUrl } from '../../PlatformUtils'
import * as dialogStyles from './Dialog.css'
import * as styles from './AccountStatusDialogs.css'
import { Button } from '../common/button/Button'

export class MustKycDialog extends React.PureComponent<{ close: () => void, openVerification: () => void }> {
	render() {
		const url = getHelpdeskRequestPage()
		return (
			<div className={dialogStyles.dialogContent} id={styles.scrollable}>
				<div className={'skin__cell-header ' + dialogStyles.dialogHeader}>
					{i18n.t('account.status.must-kyc-now.header')}
					<div className={styles.dialogClose} onClick={this.props.close}><span>X</span></div>
				</div>
				<div className={`skin__body ${dialogStyles.dialogMessage} ${dialogStyles.paddedParagraphs} ${styles.dialogMessage}`}>
					<p>{i18n.t('account.status.must-kyc-now.message-1')}</p>
					<p>{i18n.t('account.status.must-kyc-now.message-2')}</p>
				</div>
				<div className={styles.buttonBox}>
					<Button id={'account-status-must-kyc-now'} onClick={this.props.openVerification}>
						{i18n.t('account.status.must-kyc-now.button-text')}
					</Button>
				</div>
				<div className={`skin__body ${dialogStyles.dialogMessage} ${dialogStyles.paddedParagraphs} ${styles.dialogMessage}`}>
					<p>
						{i18n.t('account.status.must-kyc-now.message-support-1')}
						<a href={url} target={'_blank'}>
							{i18n.t('account.status.must-kyc-now.support-link')}
						</a>
						{i18n.t('account.status.must-kyc-now.message-support-2')}
					</p>
				</div>
			</div>
		)
	}
}

export class MustSowDialog extends React.PureComponent<{ close: () => void }> {
	render() {
		return (
			<div className={dialogStyles.dialogContent}>
				<div className={'skin__cell-header ' + dialogStyles.dialogHeader}>
					{i18n.t('account.status.must-sow-now.header')}
					<div className={styles.dialogClose} onClick={this.props.close}><span>X</span></div>
				</div>
				<div className={`skin__body ${dialogStyles.dialogMessage} ${dialogStyles.paddedParagraphs}`}>
					<p>{i18n.t('account.status.must-sow-now.message-1')} <a href={getSourceOfWealthFormUrl()} target={'_blank'}> {i18n.t('account.status.must-sow-now.message-1-link')}</a>.</p>
					<p>
						{i18n.t('account.status.must-sow-now.message-2')}
						<a
							href={'https://help.globalpoker.com/article/How-to-complete-the-Source-of-Funds-review'}
							target={'_blank'}> {i18n.t('account.status.must-sow-now.message-2-link')}
						</a>.
						&nbsp;
					</p>
				</div>
			</div>
		)
	}
}
